(function () {
  const COLLECTION_SELECTOR = ".template-collection, .template-search";
  const BUTTON_SELECTOR = '[data-action="change-layout"]';
  const STORAGE_KEY = "collection_layout_preference";

  function applyLayout(layoutMode) {
    const productColl = document.querySelector(COLLECTION_SELECTOR);
    const layoutButtons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!productColl || !layoutButtons.length) return;

    productColl.classList.toggle("collection--grid-view", layoutMode === "layout-grid");
    productColl.classList.toggle("collection--list-view", layoutMode === "list");

    layoutButtons.forEach(function (btn) {
      btn.classList.toggle("is-active", btn.dataset.layoutMode === layoutMode);
      const gridElement2 = document.querySelector(".template-collection .grid, .template-search .grid");
      if (gridElement2) gridElement2.classList.remove("opacity0");
    });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    const mode = btn.dataset.layoutMode;
    applyLayout(mode);
    localStorage.setItem(STORAGE_KEY, mode);
  });

  function initializeLayoutSwitcher() {
    const mainCollection = document.querySelector(".template-collection .grid, .template-search .grid");
    if (mainCollection) mainCollection.classList.remove("opacity0");

    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      applyLayout(saved);
    } else {
      const container = document.querySelector(".container--large[data-view]");
      if (container) {
        const collectionTemplate = document.querySelector(COLLECTION_SELECTOR);
        // FIX : .template-collection correspond au <body>. Ajouter la valeur brute ("grid")
        // activait la classe utilitaire .grid du thème (display:grid + gap) sur le body,
        // ce qui créait des bandes blanches entre le header, la barre de franco et le footer.
        if (collectionTemplate) {
          collectionTemplate.classList.add("collection-view--" + container.dataset.view);
        }
        if (container.dataset.view === "layout-grid" || container.dataset.view === "list") {
          applyLayout(container.dataset.view);
        }
      }
    }
  }

  document.addEventListener("DOMContentLoaded", initializeLayoutSwitcher);
})();

const gridElement = document.querySelector(".template-collection .grid, .template-search .grid");
if (gridElement) gridElement.classList.remove("opacity0");